export const PENDING_SCHEDULES_COLOR = '#111111'
